import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const DURATION = 2200;

export const Loader = ({ onDone }) => {
  const [count, setCount] = useState(0);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const start = performance.now();
    let raf;

    const finish = () => {
      setCount(100);
      setGone(true);
      onDone?.();
    };

    const tick = (now) => {
      const p = Math.min(1, (now - start) / DURATION);
      setCount(Math.round(p * 100));
      if (p >= 1) {
        finish();
        return;
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    // Safety net: guarantee the site becomes interactive even if rAF is
    // throttled in a background/headless tab.
    const safety = setTimeout(finish, DURATION + 600);

    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(safety);
    };
  }, []);

  return (
    <AnimatePresence>
      {!gone && (
        <motion.div
          data-testid="page-loader"
          className="fixed inset-0 z-[10001] flex flex-col justify-between bg-[#050505] px-6 py-8 md:px-14 md:py-12"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="flex items-center justify-between font-mono text-xs uppercase tracking-[0.3em] text-white/50">
            <span>CARFIX AUTO</span>
            <span>Pan India</span>
          </div>

          <div className="flex items-end justify-between">
            <span className="font-display text-[18vw] font-black leading-none text-white md:text-[12vw]">
              {String(count).padStart(3, "0")}
            </span>
            <span className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-[var(--volt)] md:mb-8">
              Loading Studio
            </span>
          </div>

          <div className="h-px w-full bg-white/10">
            <div
              className="h-px bg-[var(--volt)] transition-[width] duration-150 ease-linear"
              style={{ width: `${count}%` }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
